// extracted by mini-css-extract-plugin
module.exports = {"container":"VerificationSuccessful_container__wBHYb","title":"VerificationSuccessful_title__k_Rww","description":"VerificationSuccessful_description__9NMF4"};